import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Usuario } from '../../../models/auth.model';
import { AuthService } from '../../../services/auth.service';
import { ErrorModel } from '../../../models/error.model';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-usuario-manutencao',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './usuario-manutencao.component.html',
  styleUrl: './usuario-manutencao.component.css',
})
export class UsuarioManutencaoComponent implements OnInit {
  usuarioForm: FormGroup;
  isLoading = false;
  usuarioLogado: Usuario | null = null;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.usuarioForm = this.fb.group({
      id: [0, [Validators.required]],
      nomeUsuario: ['', [Validators.required]],
      nomeCompleto: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      ativo: [true],
      secret: ['', [Validators.required]],
      confirmarSenha: ['', [Validators.required]]
    }, { validators: this.validarConfirmacaoSenha });
  }

  ngOnInit(): void {
    this.usuarioLogado = this.authService.getUser();

    if (!this.usuarioLogado) {
      this.toastr.error('Usuário não identificado. Faça login novamente.');
      this.router.navigate(['/login']);
      return;
    }

    this.usuarioForm.patchValue({
      ...this.usuarioLogado,
      secret: '',
      confirmarSenha: ''
    });

    this.usuarioForm.get('nomeUsuario')?.disable({ emitEvent: false });
    this.usuarioForm.get('email')?.disable({ emitEvent: false });
  }

  salvar(): void {
    if (!this.usuarioLogado) {
      this.toastr.error('Usuário não identificado.');
      return;
    }

    if (this.usuarioForm.invalid) {
      this.usuarioForm.markAllAsTouched();
      this.toastr.warning('Preencha corretamente os campos obrigatórios.');
      return;
    }

    if (!this.senhasConferem) {
      this.usuarioForm.markAllAsTouched();
      this.toastr.warning('As senhas informadas devem ser iguais.');
      return;
    }

    this.isLoading = true;
    const formValue = this.usuarioForm.getRawValue();
    const payload: Usuario = {
      ...formValue,
      id: this.usuarioLogado.id,
      nomeUsuario: this.usuarioLogado.nomeUsuario,
      email: this.usuarioLogado.email
    };

    delete (payload as unknown as { confirmarSenha?: string }).confirmarSenha;

    this.authService.updateUsuario(this.usuarioLogado.id, payload).subscribe({
      next: () => {
        this.isLoading = false;
        this.toastr.success('Cadastro atualizado com sucesso.');
        this.router.navigate(['/home', 'homepage']);
      },
      error: (err) => {
        this.isLoading = false;
        const erro = err?.error as ErrorModel | undefined;
        this.toastr.error(erro?.message || 'Não foi possível atualizar o cadastro.');
      }
    });
  }

  voltar(): void {
    this.router.navigate(['/home', 'homepage']);
  }

  get senhasConferem(): boolean {
    return !this.usuarioForm.hasError('senhaDiferente');
  }

  private validarConfirmacaoSenha(control: AbstractControl): ValidationErrors | null {
    const senha = control.get('secret')?.value;
    const confirmarSenha = control.get('confirmarSenha')?.value;

    if (!senha || !confirmarSenha) {
      return null;
    }

    return senha === confirmarSenha ? null : { senhaDiferente: true };
  }

}
